<template>
    <div style="width: 100%" class="public">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="text-align: right;">
            <el-row style="background-color: #EEEEEE;">
                <el-col :span="24">
                    <el-button type="info" size="small" @click="returnPage">返回</el-button>
                    <el-button type="warning" size="small" @click="save">保存</el-button>
                </el-col>
            </el-row>
        </div>
        <el-form  ref="form" :rules="rules"  :model="form" label-width="80px"
                  >
            <!-- 基本信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>基本信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item label="商品编码" >
                            <el-input v-model.trim="form.commId" :disabled="true" style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="商品SKU" >
                            <el-input v-model.trim="form.commSku"  style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="商品状态" >
                            <el-radio-group v-model="form.commStatus">
                                <el-radio label="01">在售</el-radio>
                                <el-radio label="02">热销</el-radio>
                                <el-radio label="03">新品</el-radio>
                                <el-radio label="04">清仓</el-radio>
                                <el-radio label="05">停售</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!--商品分类-->
                        <el-form-item label="商品分类" prop="typeId">
                            <TreeSelect :props="treeSelect" :options="dataList"  v-model="form.typeId" ref="childSelTree"
                                        style="width: 30%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                        </el-form-item>
                        <el-form-item label="中文名称" >
                            <el-input v-model.trim="form.chinName"  style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="英文名称" >
                            <el-input v-model.trim="form.engName"  style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="平台SKU" >
                            <el-input v-model.trim="form.platSku" style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="识别码" >
                            <el-input v-model.trim="form.recoNo"  style="width: 200px;" size="small"></el-input>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!--来源URL-->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>来源URL</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main style="width: 100%">
                        <el-form-item label="来源URL" >
                            <el-row v-for="(item,index) in form.urlList">
                                <el-input placeholder="http://"   v-model.trim="form.urlList[index].inuptUrlValue"  style="width: 500px;" size="small">
                                </el-input>
                                <el-button type="primary" size="small" @click="visitUrl(form.urlList[index].inuptUrlValue)">访问</el-button>
                                <el-button v-show="index==0" icon="el-icon-plus" @click="addUrl"  size="small"></el-button>
                                <el-button v-show="index>0" icon="el-icon-minus"  @click="deleteUrl(index)" size="small"></el-button>
                            </el-row>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!--图片信息-->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>图片信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main style="width: 100%">
                        <el-row>
                            <el-col :span="8">
                                <el-upload
                                        :show-file-list="false"
                                        class="upload-demo"
                                        action="#"
                                        multiple
                                        :http-request="function (res) { return handleParam(res)}"
                                >
                                    <span style="margin-right: 15px">产品图片:</span>
                                    <el-button size="small" type="primary" >点击上传</el-button>
                                </el-upload>
                            </el-col>
                        </el-row>
                        <el-row>
                            <draggable @start="start" @end="end" :list="form.picList">
                                <el-col :span="2" v-for="(o, index) in form.picList" :key="index" :offset="1">
                                    <el-card :body-style="{ padding: '1px' }">
                                        <el-popover trigger="hover" title="" placement="right" >
                                            <img :src="o.img"
                                                 style="width: 200px;height: 200px">
                                            <img slot="reference" :src="o.img" style="height: 100px;width: 110px">
                                        </el-popover>
                                        <div style="padding-top: 10px;">
                                            <el-row>
                                                <el-col :span="17" style="font-size: 14px">
                                                    {{o.picPx}}
                                                </el-col>
                                                <el-col :span="7" style="margin-top: -4px">
                                                    <!--<el-button type="text" class="button" @click="deletePic(index)">移除</el-button>-->
                                                    <el-link type="primary" @click="deletePic(index)">移除</el-link>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-card>
                                </el-col>

                            </draggable>
                        </el-row>
                    </el-main>
                </el-container>
            </div>

            <!-- 人员信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>人员信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item label="开发人员" prop="code">
                            <el-select clearable  v-model="form.empNo" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in shopAllUserOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!--商品分类-->
                        <el-form-item label="采购员">
                            <el-select clearable  v-model="form.proEmpNo" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in shopAllUserOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!-- 仓库信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>仓库信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item>
                            <el-radio-group v-model="form.wareId">
                                <el-radio
                                        v-for="item in wareList"
                                        :label="item.value"
                                >{{item.label}}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
            <!-- 重量信息 -->
            <div style="background-color: #FFFFFF;margin-top: 15px;width: 100%">
                <el-container>
                    <!-- 头部 -->
                    <el-header style="color: #A2A2A2;margin-top: 15px" height="25px"><strong>人员信息</strong></el-header>
                    <!-- 分割线 -->
                    <el-divider margin="8px,0"></el-divider>
                    <!-- 主内容 -->
                    <el-main>
                        <el-form-item label="商品重量" prop="weight">
                            <el-input size="mini" v-model.trim="form.weight"  placeholder="仅支持数字" style="width: 200px;margin-right: 10px" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g);"></el-input>(g)
                        </el-form-item>
                        <el-form-item label="商品尺寸">
                            <el-row>
                                <el-col :span="3">
                                    <el-input v-model.trim="form.commLong"  placeholder="长" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                <el-col :span="3" style="margin-left: 8px">
                                    <el-input v-model.trim="form.commWide"  placeholder="宽" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                <el-col :span="3" style="margin-left: 8px;margin-right: 10px">
                                    <el-input v-model.trim="form.commHigh"  placeholder="高" size="mini" onkeyup="this.value=this.value.replace(/[^\d]/g, '')"></el-input>
                                </el-col>
                                (CM)
                            </el-row>
                        </el-form-item>
                    </el-main>
                </el-container>
            </div>
        </el-form>

        <!-- 回到顶部 -->
        <el-backtop></el-backtop>


    </div>
</template>

<script>
    //拖动图片插件
    import draggable from 'vuedraggable';
    import ElRow from "element-ui/packages/row/src/row";
    import {selectWareListRadio,save,getMaxId,addSingleGoods} from '@/api/store/storeManage';
    import {goodsUploadImg,getAllShopUser,getUserId} from '@/api/product/common';
    import TreeSelect from '@/components/common/treeSelect';
    import {calcDescartes} from '@/utils/jn';
    import {loadDataMap} from '@/api/store/commType'

    const  cityOptions = ['默认仓库', '仓库1', '仓库2', '仓库3'];
    export default {
        components: {
            ElRow,
            TreeSelect,
            draggable
        },
        data: function() {
            return {
                form: {
                    commId:null, //商品编码
                    commSku:null, //商品SKU
                    commStatus:'01', //商品状态
                    chinName:null, //中文名字
                    engName:null,//英文名字
                    platSku:null, //平台SKU
                    recoNo:null,  //识别码
                    typeId: null, //商品分类
                    empNo: null, //开发员
                    proEmpNo: null,//采购员
                    wareId: null, //仓库
                    weight: null, //商品净重
                    commLong: null, //长
                    commWide: null,//宽
                    commHigh: null, //高
                    urlList:[
                        {
                            inuptUrlValue:null,
                        },

                    ],//来源URL集合,默认有第一个
                    picList:[],
                },
                picIndex: 0,//表格内图片的索引
                //树形数据
                dataList: [],
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                    pCatId: 'pCatId',
                },
                wareList: [],//仓库列表
                shopAllUserOptions: [],//用户列表
                rules: {
                    chinName: [
                        { required: true, message: '请输入中文名称', trigger: 'blur' },
                    ],
                    engName: [
                        { required: true, message: '请输入英文名称', trigger: 'blur' },
                    ],
                    url: [
                        { required: true, message: '请输入URL', trigger: 'blur' },
                    ],
                    receNo: [
                        { required: true, message: '请输入识别码', trigger: 'blur' },
                    ],
                    weight: [
                        { required: true, message: '请输入商品净重', trigger: 'blur' },
                    ],
                    typeId: [
                        { required: true, message: '请选择商品分类', trigger: 'blur' },
                    ],
                    commSku: [
                        { required: true, message: '请输入商品SKU', trigger: 'blur' },
                    ],
                },

            }


        },
        methods:{
            handleClose(tag,index) {
                this.form.attributList[index].dynamicTags.splice(this.form.attributList[index].dynamicTags.indexOf(tag), 1);
                this.loadSku();
            },


            //表格checkbox选择
            handleSelectionChange(){

            },

            //覆盖默认上传行为
            handleParam(data,index){
                this.uploadByPicType(data,index)
            },
            //上传图片时,区分不同的图片类型参数
            uploadByPicType(data,index){
                var formData = new FormData();
                //文件
                formData.append("imageFile", data.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        this.$set(this.form.tableData[index], 'picUrl', res.data.img);
                        for (var i=0; i<this.form.tableData.length; i++){
                            if(this.form.tableData[i].picUrl=='' || this.form.tableData[i].picUrl==null){
                                this.$set(this.form.tableData[i], 'picUrl', res.data.img);
                            }
                        }
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //树形赋值
            getTreeNodeId(val) {
                this.form.typeId = val;
            },
            getTree(that){
                // 获取本平台树
                loadDataMap().then((res) => {
                    that.dataList=that.optionData(res.data);
                    setTimeout(function () {
                        that.$refs.childSelTree.initHandle();
                    },100);
                })
            },
            //处理tree的数据
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
            //获取店铺下的所有用户
            getAllShopUser(){
                getAllShopUser().then((res) => {
                    this.shopAllUserOptions =res.data;
                })
            },
            //获取用户ID
            getUserId(){
                getUserId().then((res) => {
                    this.form.empNo=res.data
                    this.form.proEmpNo=res.data
                })
            },
            //获取用户下的所有仓库
            selectWareListRadio(){
                selectWareListRadio().then((res) => {
                    this.wareList=res.data
                })
            },
            //保存多属性
            save(){
                // this.$refs.form.validate((valid) => {
                //     if (valid) {
                //         var form = this.form;
                //         form['commType']='02';
                //         //必须要有一个sku
                //         var attributList = this.form.attributList;
                //         if (attributList.length <=0){
                //             this.msgError("至少添加一个SKU");
                //             return;
                //         }
                //         save(form).then((res) => {
                //             this.msgSuccess(res.msg);
                //         })
                //     } else {
                //         this.msgError("请输入必填信息");
                //         return false;
                //     }
                // });
                let form = this.form;
                form['commType']='01';
                addSingleGoods(form).then((res) => {
                    this.msgSuccess(res.msg)
                })

            },
            returnPage(){
                this.$router.push({path:"/repository/manage/goodsManage",query:{}})
            },
            deleteAttrName(index){
                this.form.attributList.splice(index,1);
                this.loadSku();
            },
            //获取最大的ID值
            getMaxId(){
                getMaxId().then((res) => {
                    this.form.commId=res.data;
                })
            },
            start(e) {
            },
            end(e) {
            },
            //覆盖默认上传行为
            handleParam(res){
                var formData = new FormData();
                //文件
                formData.append("imageFile", res.file);
                goodsUploadImg(formData).then(res => {
                    if(res.code == 200){
                        var param={
                            'img':res.data.img,
                            'picPx':res.data.picPx,
                        }
                        this.form.picList.push(param)
                        this.msgSuccess(res.msg);
                    }
                }).catch(err => {});
            },
            //添加URL
            addUrl(){
                this.form.urlList.push(
                    {
                        inuptUrlValue:null,
                    }
                )
            },
            //删除URL
            deleteUrl(index){
                this.form.urlList.splice(index,1);
            },
            // 移除图片
            deletePic(index){
                this.form.picList.splice(index, 1);
            },
            //访问来源URL
            visitUrl(url){
                window.open(url);
            },

        },
        //进来就调用
        created() {
            var that = this;
            that.getTree(that);
            that.getUserId();
            that.getAllShopUser();
            that.selectWareListRadio();
            that.getMaxId();
        }
    }
</script>

<style>

</style>
